import {type DropdownNs} from "@shared/types";

export const customPropertyDropdownOptions: DropdownNs.DropdownOptionsItem[] = [{
    name: 'Custom Properties',
    icon: 'Settings',
    iconType: 'fal',
    subOptions: {
        title: 'Custom Properties',
        options: [
            {
                name: 'Text',
                inputName: 'text',
                inputType: 'text',
                iconType: 'fal',
                icon: 'Type',
                value: 'custom',
            },
            {
                name: 'Number',
                inputName: 'number',
                inputType: 'text',
                iconType: 'fal',
                icon: 'Hash',
                value: 'custom',
                propertyDescription: {
                    img: 'images/text.jpg',
                    summary: 'Number',
                },
            },
            {
                name: 'Date & Time',
                inputName: 'datetime',
                inputType: 'text',
                iconType: 'fal',
                icon: 'Calendar',
                value: 'custom',
            },
            {
                name: 'Email',
                inputName: 'email',
                inputType: 'text',
                iconType: 'fal',
                icon: 'AtSign',
                value: 'custom',
            },
            {
                name: 'Phone',
                inputName: 'phone',
                inputType: 'text',
                iconType: 'fal',
                icon: 'Phone',
                value: 'custom',
            },
            {
                name: 'URL',
                inputName: 'url',
                inputType: 'text',
                iconType: 'fal',
                icon: 'Link',
                value: 'custom',
            },
        ],
    },
},
];
